module.exports = __webpack_public_path__ + "media/promo/lum2021/images/contest-e107f6ad243771ec67ab30d0b56b89b6.jpg";